import React from 'react'
import {formatDate} from "../../../../../helpers/formatDate";

function TableItem(props) {
    const {item} = props

    const formatNumber = function (number, n, x, s, c) {
        let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = number.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };

    return (
        <tr className="RowItem">
            <td className="queueId">{item.transactionAt && formatDate(item.transactionAt)}</td>
            <td className="queueName">{formatNumber(item.amount, 0, 3, '.', ',')}</td>
            <td className="Status text-center">
                <div className={`itemStatus ${item.type === 'SUB' ? 'red' : 'blue'}`}>{item.type}</div>
            </td>
            <td className="Status text-center">
                <div className={`itemStatus ${item.status === 'SUCCESS' ? 'blue' : 'red'}`}>{item.status}</div>
            </td>
            <td className="Status text-center">{formatNumber(item.balance, 0, 3, '.', ',')}</td>
        </tr>
    )
}

export default TableItem
